/**
 * Checks if a value is empty (null, undefined, or empty array).
 * Useful for checking array values that may be empty.
 */
export const isEmptyArray = (value: unknown): boolean => {
  return (
    value === null ||
    value === undefined ||
    (Array.isArray(value) && value.length === 0)
  );
};
